import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {
  setFloorplanSelectionRect,
  setSelectedFloorplanId,
} from '../actions/floorplans.actions';
import { loadProjectFloorplans } from '../thunks/loadProjectFloorplans.thunk';
import { uploadFloorplan } from '../thunks/uploadFloorplan.thunk';
import { deleteFloorplanThunk } from '../thunks/deleteFloorplan.thunk';
import { updateFloorplan } from '../thunks/updateFloorplan.thunk';
import { enqueueSnackbar } from 'notistack';
import i18n from 'i18next';

const floorplansAdapter = createEntityAdapter();

const initialState = {
  floorplans: floorplansAdapter.getInitialState(),
  loading: false,
  selectedFloorplanId: '',
  selectionRect: null,
  uploadProgress: 0,
};

export const floorplansSlice = createSlice({
  name: 'floorplans',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(setSelectedFloorplanId, (state, action) => {
        state.selectedFloorplanId = action.payload;
        state.selectionRect = null;
      })
      .addCase(setFloorplanSelectionRect, (state, action) => {
        state.selectionRect = action.payload;
      })

      // loadProjectFloorplans
      .addCase(loadProjectFloorplans.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadProjectFloorplans.fulfilled, (state, action) => {
        state.loading = false;
        floorplansAdapter.setAll(state.floorplans, action.payload.floorplans);
      })
      .addCase(loadProjectFloorplans.rejected, (state) => {
        state.loading = false;
      })

      // uploadFloorplan
      .addCase(uploadFloorplan.pending, (state) => {
        state.uploadProgress = 0;
      })
      .addCase(uploadFloorplan.fulfilled, (state, action) => {
        state.uploadProgress = 0;
        floorplansAdapter.addOne(state.floorplans, action.payload);
        enqueueSnackbar(i18n.t('gallery.floorplan_added'), {
          variant: 'success',
        });
      })
      .addCase(uploadFloorplan.rejected, (state) => {
        state.uploadProgress = 0;
        enqueueSnackbar(i18n.t('gallery.floorplan_add_error'), {
          variant: 'error',
        });
      })

      // deleteFloorplan
      .addCase(deleteFloorplanThunk.fulfilled, (state, action) => {
        const { id, floorplanId } = action.payload;
        floorplansAdapter.removeOne(state.floorplans, id || floorplanId);
        enqueueSnackbar(i18n.t('gallery.floorplan_deleted'), {
          variant: 'success',
        });
      })
      .addCase(deleteFloorplanThunk.rejected, () => {
        enqueueSnackbar(i18n.t('gallery.floorplan_delete_error'), {
          variant: 'error',
        });
      })

      // updateFloorplan
      .addCase(updateFloorplan.fulfilled, (state, action) => {
        const { id, ...changes } = action.payload;
        floorplansAdapter.updateOne(state.floorplans, { id, changes });
      })
      .addCase(updateFloorplan.rejected, () => {
        enqueueSnackbar(i18n.t('gallery.floorplan_update_error'), {
          variant: 'error',
        });
      });
  },
});
